<template>
  <div v-if="user" class="user-base-info">
    <el-descriptions title="基本信息" :column="3" border>
      <el-descriptions-item v-for="column in columns.base" :key="column.key" label-align="right" align="center"
        label-class-name="user-base-info-item-label" :span="column.span" :label="column.label">
        {{column.formatter ? column.formatter(user) : user[column.key]}}
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions title="实名信息" :column="3" border>
      <el-descriptions-item v-for="column in columns.real" :key="column.key" label-align="right" align="center"
        label-class-name="user-base-info-item-label" :span="column.span" :label="column.label">
        {{column.formatter ? column.formatter(user) : user[column.key]}}
      </el-descriptions-item>
      <el-descriptions-item  label-align="right" align="center"
        label-class-name="user-base-info-item-label" span="3" label="身份证照">
        <el-image v-for="(path, index) in idCardPaths" :key="index" :src="getFileUrl(path)" :preview-src-list="[getFileUrl(path)]">
        </el-image>
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions title="其他信息" :column="3" border>
      <el-descriptions-item v-for="column in columns.other" :key="column.key" label-align="right" align="center"
        label-class-name="user-base-info-item-label" :span="column.span" :label="column.label">
        {{column.formatter ? column.formatter(user) : user[column.key]}}
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { getFileUrl } from '@/utils/common';

export default defineComponent({
  props: {
    user: Object
  },
  computed: {
    idCardPaths() { // 身份证照地址路径数组
      let ret = [];
      if (this.user && this.user.idCardPath && this.user.idCardPath.length) {
        this.user.idCardPath.split(',').forEach(path => ret.push(path));
      }
      return ret;
    }
  },
  data() {
    return {
      getFileUrl,
      columns:{
        base: [
          { label: '用户名', key: 'loginName' },
          { label: '电话', key: 'phone' },
          { label: '微信id', key: 'wechatId' },
          { label: '性别', key: 'sex' },
          { label: '年龄', key: 'age' },
          { label: '婚姻状况', key: 'marriageStatus' },
          { label: '注册时间', key: 'registerTimeString' },
          { label: '是否有效', key: 'isEffective', formatter: (u) => u.isEffective === 1 ? '是' : '否' },
          { label: '锁定时间', key: 'lockTimeString' }
        ],
        real: [
          { label: '是否实名认证', key: 'isReal', formatter: (u) => u.isReal === 1 ? '是' : '否'  },
          { label: '身份证号', key: 'idCardNo', span: 2 },
          { label: '省', key: 'idProvince' },
          { label: '市', key: 'idCity' },
          { label: '县', key: 'idCounty' },
          { label: '详细地址', key: 'address', span: 3 }
        ],
        other: [
          { label: '紧急联系人类型', key: 'emergencyContactTypeName' },
          { label: '紧急联系人姓名', key: 'emergencyContactName' },
          { label: '紧急联系人电话', key: 'emergencyContactPhone' },
          { label: '银行名称', key: 'bankName' },
          { label: '开户行', key: 'bankDeposit' },
          { label: '银行卡号', key: 'bankCardNo' }
        ]
      }
    };
  }
})
</script>

<style lang="scss" scoped>
.user-base-info {
  .el-descriptions + .el-descriptions {
    margin-top: 25px;
    .el-image {
      width: 250px;
      height: 150px;
    }
    .el-image + .el-image {
      margin-left: 25px;
    }
  }
}
</style>
<style lang="scss">
.user-base-info-item-label {
  width: 150px;
}
</style>
